/**
 * Which range period the Progress page opens on (#5456).
 *
 * The page can be opened with a period in its params: Home pushes one, the weekly check-up's
 * "see all" links push one, and an old address can carry any of them. The page offers a
 * different set of periods when the coaching dashboard switch is on, so an incoming value is
 * mapped onto a period the page offers right now. Kept free of Angular so a unit test can drive
 * it (`progress-period.test.ts`).
 */

import { TimePeriod } from './progress-interface';

/** the period the page opens on with the coaching dashboard on and no usable param */
export const OVERVIEW_DEFAULT_PERIOD: TimePeriod = '2weeks';
/** the period the page opens on with the coaching dashboard off and no usable param */
export const CLASSIC_DEFAULT_PERIOD: TimePeriod = 'month';

/**
 * The period to show for an incoming one.
 *
 * Dashboard on: `week` becomes 2 weeks, `month` 4 weeks, `quarter` 12 weeks; `year`, `all` and the
 * week-count periods stay; nothing, or anything unknown, becomes 2 weeks.
 *
 * Dashboard off: the five classic periods stay; nothing, a week-count period or anything unknown
 * becomes `month`, which is what the page opened on before #5456.
 */
export function overviewPeriodForIncoming(incoming: unknown, coachingDashboardOn: boolean): TimePeriod {
  if (coachingDashboardOn) {
    switch (incoming) {
      case 'week': return '2weeks';
      case 'month': return '4weeks';
      case 'quarter': return '12weeks';
      case 'year':
      case 'all':
      case '2weeks':
      case '4weeks':
      case '8weeks':
      case '12weeks':
        return incoming;
      default:
        return OVERVIEW_DEFAULT_PERIOD;
    }
  }
  switch (incoming) {
    case 'week':
    case 'month':
    case 'quarter':
    case 'year':
    case 'all':
      return incoming;
    default:
      return CLASSIC_DEFAULT_PERIOD;
  }
}
